import FrameSettings from '@screens/frame/settings'
import { Redirect, useLocalSearchParams } from 'expo-router'

export default function FrameSettingsPage() {
  const { frameId } = useLocalSearchParams<{ frameId?: string }>()

  if (!frameId) {
    return <Redirect href="/frame/select" />
  }

  return <FrameSettings frameId={frameId} />
}
